import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content } from 'ionic-angular';

import { AreaComum } from '../../models/area';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { AreaProvider } from '../../providers/area/area';
import { BrComService } from '../../service/BrComService';
import { FotoProvider } from '../../providers/foto/foto';
import { Mensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { Subscription } from 'rxjs';
import { ConversaArea } from '../shared/conversa/conversa-area';

@IonicPage()
@Component({
  selector: 'page-conversa-area',
  templateUrl: 'conversa-area.html',
})
export class ConversaAreaPage extends ConversaArea {

  @ViewChild(Content) content: Content;
  public area: AreaComum;
  private bsEmpresa: Subscription;
  public possuiMensagensAntigas: boolean;
  
  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private changeDetectorRef: ChangeDetectorRef, 
    private events: Events,
    private areaProvider: AreaProvider, 
    private areaLocalProvider: AreaLocalProvider,
    brComService: BrComService, 
    mensagemProvider: MensagemProvider, 
    fotoProvider: FotoProvider,
    empresaLocalProvider: EmpresaLocalProvider) {
      super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    this.possuiMensagensAntigas = true;
    this.area = this.navParams.get('area');
    this.events.subscribe(`msg.area.${this.area.idArea}`, (mensagem: Mensagem) => {
      this.area.mensagens.push(mensagem);
      this.changeDetectorRef.detectChanges();
      this.scrollBottom(this.content);
      this.notificarMensagemLida();
    });
    this.bsEmpresa = this.empresaLocalProvider.$empresa.skip(1).subscribe(
      () => {
        this.area = this.areaLocalProvider.getArea(this.area.idArea);
        this.changeDetectorRef.detectChanges();
      }
    )
  }

  ionViewWillLeave() {
    this.bsEmpresa.unsubscribe();
    this.events.unsubscribe(`msg.area.${this.area.idArea}`);
    this.areaLocalProvider.removerMensagensAcimaDoLimite(this.area.idArea);
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.content.scrollToBottom(0);
    }, 50);
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
    this.notificarMensagemLida();
  }

  private notificarMensagemLida(): void {
    if (this.hasMensagensNaoLidas()) {
      this.areaLocalProvider.marcarMensagensLidas(this.area.idArea, this.empresa.IdUsuario);
      this.areaProvider.notificarMensagensLidas(this.empresa.IdUsuario, this.brComService.getIdDevice(), this.area.idArea).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    if (!this.area.mensagens) {
      return false;
    }
    const result = this.area.mensagens.find(m => m.origem === "L" && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  public getMensagensAntigas(infinity: any): void {
    const mensagensArea = this.area.mensagens;
    const idEnvioMaisAntigo = mensagensArea[0].idEnvio;
    this.areaProvider.getMensagensAntigasArea(this.area.idArea, this.empresa.IdUsuario, idEnvioMaisAntigo).subscribe(
      mensagens => {
       if (mensagens && mensagensArea.length > 0) {
          this.area.mensagens = mensagens.concat(mensagensArea);
          this.areaLocalProvider.updateArea(this.area);
        } else {
          this.possuiMensagensAntigas = false;
       }
      }, () => {
        infinity.complete();
      }, () => {
        infinity.complete();
      }
    )
  }

  public podePegarMensagensAntigas(): boolean {
    return this.possuiMensagensAntigas && this.area.mensagens && this.area.mensagens.length >= this.areaLocalProvider.limiteDeMensagens;
  }

  public  enviarMensagem(mensagem: string): void {
    if (mensagem.trim() !== "") {
      const idUsuarioDestino = 0;
      const msg = this.criarMensagemSimplesEnvio(mensagem, idUsuarioDestino);
      this.adicionarNovaMensagem(msg);
      this.enviarMensagemUsuarioArea(msg);
    }
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    if (!this.area.mensagens) {
      this.area.mensagens = [];
    }
    this.area.mensagens.push(msg);
    this.changeDetectorRef.detectChanges();
    this.scrollBottom(this.content);
    this.areaLocalProvider.adicionarNovaMensagem(this.area.idArea, msg);
  }

  private atualizarMensagemComFalhaNoEnvio(msg: Mensagem) {
    this.area.mensagens.find(m => m.idEnvio === msg.idEnvio).falhaNoEnvio = true;
    this.changeDetectorRef.detectChanges();
    // se a a conversa está no fim seria legal dar um scroll, caso contrario não fazer nada
    this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
  }

  private enviarMensagemUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemSimplesUsuarioArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.area.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemImagemUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemImagemUsuarioArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.area.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  private enviarMensagemArquivoUsuarioArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemArquivoUsuarioArea(this.empresa.IdUsuario, this.area.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaLocalProvider.atualizarMensagemEnviada(this.area.idArea, msg.idEnvio, idEnvio);
        this.area.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public async enviarArquivo(file: File): Promise<void> {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemArquivoEnvio(idUsuarioDestino, arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        const i = this.area.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.area.mensagens[i] = msg;
        this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
        this.enviarMensagemArquivoUsuarioArea(msg);
      }, error => {
        console.log(error);
      }
    )
  }

  public enviarImagem(imagem: File): void {
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemImagemEnvio(idUsuarioDestino);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        const i = this.area.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.area.mensagens[i] = msg;
        this.areaLocalProvider.atualizarMensagem(this.area.idArea, msg);
        this.enviarMensagemImagemUsuarioArea(msg);
      }, error => {
        console.log(error)
      }
    )
  }

  public getImagemArea(): string {
    return this.obterImagemComHash(this.area.hashImagem);
  }

  public getImagemUsuario(mensagem: Mensagem): string {
    return this.obterImagemComHash(mensagem.hashLogotipo);
  }

  public trackBy(index: number, msg: Mensagem): any {
    if (!msg) {
      return null;
    }
    return  `${index}:${msg.statusMensagemRecebida}:${msg.statusMensagemLida}:${msg.pendente}:${msg.falhaNoEnvio}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-area/conversa-area.ts